import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HomeLayout from '../../../containers/HomeLayout';

import * as actions from '../../../store/actions/messageActions';
import * as profileActions from '../../../store/actions/profileActions';
import { useSelector, useDispatch } from 'react-redux';

import '../../../assets/css/chat.css';

const Conversations = () => {
    const messageState = useSelector(state => state.message);
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();

    const renderConversationBlocks = () => {
        var existingNames = [];
        var profileConversaitionBlocks = messageState.messages.map((message, i) => {
            var matchedProfileName = getProfileMatchName(message.messageRoom.split('-'));
            var originalMatchedProfileName = matchedProfileName.match(/[A-Z]+(?![a-z])|[A-Z]?[a-z]+|\d+/g).join(' ');
            
            if (checkMessageRoomLastMessage(message)) {
                return (
                    <Link to={`/conversations/messages/${originalMatchedProfileName}`} style={{textDecoration: 'none'}} key={i}>
                        <div className="conversation-block">
                            <div className="read-status">
                                <p>Your Move</p>
                            </div>
                            
                            <div className="conversation">
                                <p className="convo-name">{originalMatchedProfileName}</p>
                                <p className="convo-text">
                                    {message.messageText}
                                </p>
                            </div>
                        </div>
                    </Link>
                )
            }
        })

        return profileConversaitionBlocks;
    }

    const getProfileMatchName = splitMessageRoom => {
        if (splitMessageRoom.indexOf(profileState.userProfile.profileName.split(' ').join('')) === 0) {
            return splitMessageRoom[1];
        }
        else{
            return splitMessageRoom[0];
        }
    }

    const checkMessageRoomLastMessage = (message) => {
        var lastMessage = messageState.messages.filter(x => x.messageRoom === message.messageRoom);
        if (lastMessage[lastMessage.length-1].messageId === message.messageId) {
            return true;
        }
        else{
            return false;
        }
    }

    useEffect(() => {
        dispatch(actions.fetchMessageRoomMessages(profileState.userProfile.profileName.split(" ").join("")));
    }, []);

    return (
        <HomeLayout>
            <div className="content-row">
                <div className="content-title">
                    <h1>Conversations</h1>
                    <h4>My Matches</h4>
                </div>

                <div className="content-blocks">
                    {renderConversationBlocks()}
                </div>
            </div>

        </HomeLayout>
    );
}

export default Conversations;